// Shared avatar helpers — deterministic per-name color + initials, so the same
// student always renders the same avatar across sign-out, attendance, emergency.

const AVATAR_COLORS = [
  "#6b8fb0", "#c98a5e", "#5fa37f", "#8a6bb0", "#b06b89", "#5e9bc9",
];

export function avatarColor(name) {
  let h = 0;
  const str = String(name);
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

export function initials(name) {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  const first = parts[0][0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}
